import { List, ListItem, ListItemButton, ListItemText } from "@mui/material";


const GTSideMenu = ({setMode}:{setMode: (to:('desc' | 'test' | 'result')) => void}) => {
    return (
        <>
            <List sx={{ width: '100%', bgcolor: 'background.paper', position: 'fixed' }}>
                <ListItem>
                    <ListItemText primary="認知特性テスト" />
                </ListItem>
                <ListItem disablePadding sx={{backgroundColor: '#f8f8f8'}}>
                    <ListItemButton role={undefined} onClick={() => setMode('desc')} dense>
                        <ListItemText primary={`□ 認知特性テスト-解説-`} />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding sx={{backgroundColor: '#f8f8f8'}}>
                    <ListItemButton role={undefined} onClick={() => setMode('test')} dense>
                        <ListItemText primary={`□ 認知特性テスト-問題-`} />
                    </ListItemButton>
                </ListItem>
            </List>
        </>
    )
}

export default GTSideMenu;